import { format, toZonedTime } from 'date-fns-tz'
import moment from 'moment'

import { buildCsvFilename, downloadCsv } from '@/utils/file'

import { formatMoney } from '../../../helpers/helpers'

export const AttendeeStatusValue = {
  All: 'all',
  SignedUp: 'signedUp',
  CheckedIn: 'checkedIn',
  Removed: 'removed',
}

export const makeAttendeeStatus = (t) => ({
  All: {
    label: t('attendees:status.all'),
    value: AttendeeStatusValue.All,
  },
  SignedUp: {
    label: t('attendees:status.signedUp'),
    value: AttendeeStatusValue.SignedUp,
  },
  CheckedIn: {
    label: t('attendees:status.checkedIn'),
    value: AttendeeStatusValue.CheckedIn,
  },
  Removed: {
    label: t('attendees:status.removed'),
    value: AttendeeStatusValue.Removed,
  },
})

export const getAttendeeStatus = (removed, participation, t) => {
  const attendeeStatus = makeAttendeeStatus(t)
  return removed
    ? attendeeStatus.Removed
    : participation
      ? attendeeStatus.CheckedIn
      : attendeeStatus.SignedUp
}

export const downloadCSV = (attendees, t) => {
  const data = []
  const attendingFields = [
    {
      label: t('attendees:columns.attendee'),
      value: 'attendee',
    },
    {
      label: t('attendees:columns.unit'),
      value: 'unit',
    },
    {
      label: t('attendees:columns.email'),
      value: 'email',
    },
    {
      label: t('attendees:columns.address'),
      value: 'address',
    },
    {
      label: t('attendees:columns.phone'),
      value: 'phone',
    },
    {
      label: t('attendees:columns.payer'),
      value: 'payer',
    },
    { label: t('attendees:columns.ticketType'), value: 'ticketType' },
    { label: t('attendees:columns.ticketPrice'), value: 'ticketPrice' },
    {
      label: t('attendees:columns.refunded'),
      value: 'refunded',
    },
    {
      label: t('attendees:columns.status'),
      value: 'status',
    },
  ]

  attendees.forEach((attendee) => {
    data.push({
      attendee: attendee.user.name,
      unit: attendee.user.apartment,
      email: attendee.user.email,
      address: attendee.user.address,
      phone: attendee.user.phone,
      payer: attendee.payer,
      ticketType: attendee.ticketType,
      ticketPrice: formatMoney(attendee.ticketPrice),
      refunded: attendee.isRefunded ? formatMoney(attendee.ticketPrice) : '',
      status: attendee.status.label,
    })
  })

  downloadCsv({
    data,
    fields: attendingFields,
    filename: buildCsvFilename({
      page: 'calendar',
      date: moment().toDate(),
    }),
  })
}

export const getFullName = (firstName, lastName) => {
  if (firstName && lastName) {
    return `${firstName} ${lastName}`
  }

  if (firstName) {
    return firstName
  }

  if (lastName) {
    return lastName
  }

  return ''
}

export const mapClientToOption = (client) => ({
  value: client.id,
  label: `${client.user.firstName} ${client.user.lastName} #${client.apartment}`,
  ...client,
})

export const formatDateRange = (startDate, endDate, timezone) => {
  if (!startDate || !endDate || !timezone) {
    return ''
  }

  const start = toZonedTime(new Date(startDate), timezone)
  const end = toZonedTime(new Date(endDate), timezone)

  const datePart = format(start, 'MMM d')
  const startTime = format(start, 'h:mm a')
  const endTime = format(end, 'h:mm a')

  return `${datePart}, ${startTime} – ${endTime}`
}

export const getAmountToRefund = (attendeeTicketPrice, guests) => {
  return (
    attendeeTicketPrice +
    guests.reduce((sum, guest) => sum + (guest.isRemoved ? 0 : guest.ticketPrice), 0)
  )
}
